import React from 'react';
import {Modal, Text} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import DeleteProjectBillToMutation from '../../../../mutations/invoicing/DeleteProjectBillToMutation';
import Util from '../../../shared/util/util';

type RemoveProjectBillToModalProps = {
	projectBillToId: string;
	projectId: string;
	closeModal: () => void;
};

const RemoveProjectBillToModal = ({projectBillToId, projectId, closeModal}: RemoveProjectBillToModalProps): JSX.Element => {
	const {formatMessage} = useIntl();
	const removeProjectBillTo = () => {
		Util.CommitMutation(
			DeleteProjectBillToMutation,
			{
				projectBillToId: projectBillToId,
				projectId: projectId,
			},
			closeModal
		);
	};

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>{formatMessage({id: 'project_settings.remove_billing_option_button_label'})}</Modal.Title>
			<Modal.Content>
				<Text size={'1'}>{formatMessage({id: 'project_settings.remove_billing_option_modal_desc'})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={removeProjectBillTo}>
					{formatMessage({id: 'common.remove'})}
				</Modal.PrimaryFooterButton>

				<Modal.SecondaryFooterButton onPress={closeModal}>
					{formatMessage({id: 'common.close'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default RemoveProjectBillToModal;
